import "./Catalogos.scss";
import { useEffect, useState, useContext } from "react";
import { Catalogo } from "..";
import {
    Row,
    Button
  } from "antd";

import { useTranslation } from "react-i18next";
import { globalContext } from "../../../../../../contexts";

const Catalogos = ({ handleChangeCatalogoActive, handlerChangeCatalogo, section, type, active=false, handleApplyFields, handleClose }) => {
  const { t } = useTranslation()
  const { currentUser, datasources } = useContext(globalContext)
  const [catType, setCatType ] = useState(type??"CONTACTPERSON")
  const [catalogos, setCatalogos ] = useState([])
  const [initCatalogos, setInitCatalogos ] = useState([])

  useEffect(() => {
      let catContacto = []
      if(catType === 'CONTACTPERSON') {
        let cat1 = {key: 'datosPersonales', hasTitle: true, title: t('forms.catalogos.datos_personales', {ns: 'forms'}), cols: 2, fields: [], active}
        //cat1.fields.push({ type: 'INPUT', title: t('forms.catalogos.nombre', {ns: 'forms'}), key: 'nombre', active: false, required: false})
        //cat1.fields.push({ type: 'INPUT', title: t('forms.catalogos.ap_paterno', {ns: 'forms'}), key: 'apPaterno', active: false, required: false})
        //cat1.fields.push({ type: 'INPUT', title: t('forms.catalogos.ap_materno', {ns: 'forms'}), key: 'apMaterno', active: false, required: false})
        cat1.fields.push({ type: 'SELECT', title: t('forms.catalogos.tipo_documento', {ns: 'forms'}), key: 'tipDoc', active: false, required: false, source:'CAT:TIPO_DOC'})
        cat1.fields.push({ type: 'INPUT', title: t('messages.aml.title.profession', { ns: "translations" }), key: 'profesion', active: false, required: false, record: {field: 'profesion'}})
        cat1.fields.push({ type: 'SELECT', title: t('forms.catalogos.nacionalidad', {ns: 'forms'}), key: 'nacionalidad', active: false, required: false, source:'CAT:COUNTRIES', record: {field: 'nacionalidad'}})
        cat1.fields.push({ type: 'SELECT', title: t('forms.catalogos.estado_civil', {ns: 'forms'}), key: 'estadoCivil', active: false, required: false, source:'CAT:ESTADO_CIVIL'})
        cat1.fields.push({ type: 'SELECT', title: t('forms.catalogos.parentesco', {ns: 'forms'}), key: 'parentesco', active: false, required: false, source:'CAT:PARENTESCO'})
        cat1.fields.push({ type: 'SELECT', title: t('forms.catalogos.pais_residencia', {ns: 'forms'}), key: 'paisResidencia', active: false, required: false, source:'CAT:COUNTRIES', record: {field: 'pais'}})
        cat1.fields.push({ type: 'DATE', title: t('forms.catalogos.fecha_nacimiento', {ns: 'forms'}), key: 'fecNac', active: false, required: false, record: {field: 'fecNac'}})
        cat1.fields.push({ type: datasources?.CAT?.PROPREL?.values?.length > 0 ? 'SELECT' : 'INPUT', title: t('messages.aml.title.purpose', { ns: "translations" }), key: 'propositoRelacion', active: false, required: false, record: {field: 'proposito'}, source:datasources?.CAT?.PROPREL?.values?.length > 0 ? 'CAT:PROPREL' : null})
        cat1.fields.push({ type: 'INPUT', title: t('messages.aml.title.alias', { ns: "translations" }), key: 'alias', active: false, required: false, record: {field: 'alias'}})
        cat1.fields.push({ type: 'SELECT', title: t('messages.aml.economicActivity', {ns: 'translations'}), key: 'acteco', active: false, required: false, source:'CAT:ACTECOS'})
        cat1.fields.push({ type: 'SELECT', title: t('messages.aml.societyType', {ns: 'translations'}), key: 'tipoSoc', active: false, required: false, source:'CAT:TIPOSOC'})
        catContacto.push(cat1)

        let cat2 = {key: 'contactoPersonal', hasTitle: true, title: t('messages.aml.contact', { ns: "translations" }), cols: 2, fields: [], active}
        cat2.fields.push({ type: 'INPUT', title: t('messages.aml.email', { ns: "translations" }), key: 'email', active: false, required: false, validation: {type: 'email'}})
        cat2.fields.push({ type: 'INPUT', title: t('messages.aml.title.phone', { ns: "translations" }), key: 'telefono', active: false, required: false, valídation: {maxLength: 12}, record: {field: 'telefono'}})
        cat2.fields.push({ type: 'INPUT', title: t('messages.aml.title.cellphone', { ns: "translations" }), key: 'celular', active: false,Regiónred: false, validation: {maxLength: 12}, record: {field: 'celular'}})
        cat2.fields.push({ type: 'INPUT', title: t('messages.aml.name', { ns: "translations" }), key: 'contacto', active: false,Regiónred: false, record: {field: 'contacto'}})
        cat2.fields.push({ type: 'INPUT', title: t('messages.aml.position', { ns: "translations" }), key: 'cargo', active: false,Regiónred: false, record: {field: 'cargo'}})
        catContacto.push(cat2)

        let cat3 = {key: 'direccionPersonal', hasTitle: true, title: t('messages.aml.address'), cols: 2, fields: [], active}
        cat3.fields.push({ type: 'SELECT', title: t('forms.catalogos.pais', {ns: 'forms'}), key: 'pais', active: false, required: false, source:'CAT:COUNTRIES', record: {field: 'paisDir'}})
        cat3.fields.push({ type: 'SELECT', title: t('forms.catalogos.region', {ns: 'forms'}), key: 'region', active: false, required: false, source:'CAT:REGIONS', record: {field: 'region'}})
        if(currentUser.cliente.pais === 'CHI') {
          cat3.fields.push({ type: 'SELECT', title: t('forms.catalogos.comuna', {ns: 'forms'}), key: 'comuna', active: false, required: false, source:'CAT:COMMUNES', record: {field: 'comuna'}})
        }else if(currentUser.cliente.pais === 'PER') {
          cat3.fields.push({ type: 'SELECT', title: t('forms.catalogos.provincia', {ns: 'forms'}), key: 'province', active: false, required: false, source:'CAT:PROVINCES'})
          cat3.fields.push({ type: 'SELECT', title: t('forms.catalogos.distrito', {ns: 'forms'}), key: 'distrito', active: false, required: false, source:'CAT:COMMUNES'})
        }
        cat3.fields.push({ type: 'INPUT', title: t('messages.aml.address', { ns: "translations" }), key: 'direccion', active: false, required: false, validation: {maxLength: 200}, record: {field: 'direccion'}})
        catContacto.push(cat3)

        /*
        let cat4 = {key: 'ocupacion', hasTitle: true, title: 'Ocupación', cols: 2, fields: [], active}
        cat4.fields.push({ type: 'SELECT', title: 'Profesión', key: 'profesion', active: false, required: false, source:'CAT:PROFESIONES'})
        cat4.fields.push({ type: 'SELECT', title: 'Condición de Trabajo', key: 'condTrabajo', active: false, required: false, source:'CAT:COND_TRABAJO'})
        cat4.fields.push({ type: 'INPUT', title: 'Ocupación Actual', key: 'ocupacion', active: false, required: false})
        cat4.fields.push({ type: 'SELECT', title: 'Actividad Economica', key: 'actEconomica', active: false, required: false, source: 'CAT:ACTECO'})
        cat4.fields.push({ type: 'INPUT', title: 'Cargo que desempeña', key: 'cargo', active: false, required: false})
        catContacto.push(cat4)

        let cat5 = {key: 'infoEmpleador', hasTitle: true, title: 'Información Empleador', cols: 2, fields: [], active}
        cat5.fields.push({ type: 'INPUT', title: 'Nombre de la Empresa', key: 'empresa', active: false, required: false})
        cat5.fields.push({ type: 'INPUT', title: 'Antigüedad', key: 'antiguedad', active: false, required: false})
        cat5.fields.push({ type: 'SELECT', title: 'Región', key: 'region', active: false, required: false, source: 'CAT:REGIONES'})
        cat5.fields.push({ type: 'SELECT', title: 'Comuna', key: 'comuna', active: false, required: false, source:'CAT:COMUNAS'})
        cat5.fields.push({ type: 'INPUT', title: 'Dirección', key: 'direccion', active: false, required: false})
        cat5.fields.push({ type: 'INPUT', title: 'Numero de calle', key: 'numCalle', active: false, required: false})
        cat5.fields.push({ type: 'INPUT', title: 'Numero de puerta', key: 'numPuerta', active: false, required: false})
        cat5.fields.push({ type: 'INPUT', title: 'Codigo postal', key: 'codPostal', active: false, required: false})
        cat5.fields.push({ type: 'DATE', title: 'Fecha de inicio', key: 'fecInicio', active: false, required: false})
        cat5.fields.push({ type: 'DATE', title: 'Fecha de término', key: 'fecTermino', active: false, required: false})
        cat5.fields.push({ type: 'INPUT', title: 'Rut de la empresa', key: 'rutEmpresa', active: false, required: false, validation: {type: 'rutEmp'}})
        catContacto.push(cat5)

        let cat6 = {key: 'infoRemuneraciones', hasTitle: true, title: 'Información de Remuneraciones', cols: 2, fields: [], active}
        cat6.fields.push({ type: 'INPUT', title: 'Remuneración Mensual', key: 'remMensual', active: false, required: false, validation: {type: 'number', decimals: 0}})
        cat6.fields.push({ type: 'INPUT', title: 'Otros ingresos mensuales', key: 'otrosIngresosMensuales', active: false, required: false, validation: {type: 'number', decimals: 0}})
        catContacto.push(cat6)

        let cat7 = {key: 'infoPropiedades', hasTitle: true, title: 'Información de Propiedades', cols: 2, fields: [], active}
        cat7.fields.push({ type: 'INPUT', title: 'Nombre de Sociedad', key: 'nombreSociedad', active: false, required: false})
        cat7.fields.push({ type: 'SELECT', title: 'Tipo de Documento', key: 'tipoDocumento', active: false, required: false, source: 'CAT:TIPO_DOC'})
        cat7.fields.push({ type: 'INPUT', title: 'Documento Identidad', key: 'documento', active: false, required: false})
        cat7.fields.push({ type: 'INPUT', title: 'Cargo Ejercido', key: 'cargo', active: false, required: false})
        cat7.fields.push({ type: 'INPUT', title: 'Porcentaje de Participación', key: 'porcentaje', active: false, required: false, validation: {type: 'number', decimals: 2}})
        catContacto.push(cat7)

        let cat8 = {key: 'infoDireccion', hasTitle: true, title: 'Información de Direccion', cols: 2, fields: [], active}
        cat8.fields.push({ type: 'SELECT', title: 'País', key: 'country', active: false, required: false, source: 'CAT:COUNTRIES'})
        cat8.fields.push({ type: 'SELECT', title: 'Región', key: 'region', active: false, required: false, source: 'CAT:REGIONS'})
        cat8.fields.push({ type: 'SELECT', title: 'Comuna', key: 'comuna', active: false, required: false, source:'CAT:COMUNAS'})
        catContacto.push(cat8)
        */

        let cat9 = {key: 'infoTributaria', hasTitle: true, title: t('messages.aml.tax.address', { ns: "translations" }), cols: 2, fields: [], active}
        cat9.fields.push({ type: 'SELECT', title: t('messages.aml.tax.country', { ns: "translations" }), key: 'paisTributario', active: false, required: false, source: 'CAT:COUNTRIES', record: {field: 'paisTributaria'}})
        cat9.fields.push({ type: 'INPUT', title: t('messages.aml.tax.address.complete', { ns: "translations" }), key: 'direccionTributaria', active: false, required: false, record: {field: 'direccionTributaria'}})
        catContacto.push(cat9)
      }
      if(section && (section.type === 'CONTACTPERSON' || section.type === 'CONTACTENTITY')) {
        catContacto.map((seccion) => {
            section.components.map(comp => {
                if(comp.key === seccion.key) {
                    seccion.active = true
                    comp.fields.map(f => {
                      let existe = false
                      seccion.fields.map(fcat => {
                        if(fcat.key === f.key) {
                            fcat.active = true
                            fcat.required = f.required
                            existe = true
                        }
                      })
                      if(!existe) {
                        seccion.fields.push({
                          type: f.typeField, 
                          title: f.title, 
                          key: f.key, 
                          active: true, 
                          required: f.required
                        })
                      }
                    })
                }
            })
        })
      }

      setCatalogos(catContacto)
      setInitCatalogos(catContacto)
    }, [catType])

  const _handleChangeCatalogoActive = (cat) => {
    let cats = []
    catalogos.map((c, i) => {
      if(c.key === cat.key) {
        cats.push(cat);
      }else {
        cats.push(c);
      }
    })

    setCatalogos(cats)
    cats = []
    initCatalogos.map((c, i) => {
      if(c.key === cat.key) {
        cats.push(cat);
      }else {
        cats.push(c);
      }
    })

    setInitCatalogos(cats)
    if(handleChangeCatalogoActive) handleChangeCatalogoActive(cats)
  }

  const _handlerChangeCatalogo = (cat, field) => {
    let _c = []
    catalogos.map(c => {
      if(c.key === cat.key) {
        let _f = []
        c.fields.map(f => {
          if(f.key === field.key) {
            _f.push(field)
          }else {
            _f.push(f)
          }
        })
        c.fields = _f
      }
      _c.push(c)
    })
    setCatalogos(_c)
    if(handleChangeCatalogoActive) handlerChangeCatalogo(_c)

    _c = []
    initCatalogos.map(c => {
      if(c.key === cat.key) {
        let _f = []
        c.fields.map(f => {
          if(f.key === field.key) {
            _f.push(field)
          }else {
            _f.push(f)
          }
        })
        c.fields = _f
      }
      _c.push(c)
    })
    setInitCatalogos(_c)
  }

  const handleSearchField = (value) => {
    if(value === '') {
        setCatalogos(initCatalogos)
        if(handleChangeCatalogoActive) handlerChangeCatalogo(initCatalogos)
    } else {
        //setInitCatalogos(catalogos)
        let cat = []
        initCatalogos.map(c => {
            if(c.title.toLowerCase().includes(value.toLowerCase())) {
                c.active = true
                cat.push(c)
            }else {
                let _f = []
                c.fields.map(f => {
                    if(f.title.toLowerCase().includes(value.toLowerCase())) {
                      _f.push(f)
                    }
                })
                if(_f.length > 0) {
                    c.active = true
                    let _c = { ...c, fields: _f }
                    cat.push(_c)
                }
            }
        })
        setCatalogos(cat)
        if(handleChangeCatalogoActive) handlerChangeCatalogo(cat)
    }
  }

  const handleSendFields = () => {
    let fields = []
    catalogos.map(c => {
        fields.push( ...c.fields.filter(f => f.active))
    })
    handleApplyFields(fields)
  }

  return (
    <div className="form-manager-catalogos">
        {/*}
        <Row style={{padding:'5px 0px'}}>
            { type ? 
            <Col span={18}>
              <h4>Catalogo de datos{catType === "CONTACTPERSON" ? ' de Persona Natural' : catType === "CONTACTENTITY" ? ' de Persona Jurídica': ''}</h4>
            </Col>
            :
            <>
              <Col span={4}>
                <h4>Seleccionar Catálogo</h4>
              </Col>
              <Col span={4}>
                <Select onChange={(value) => setCatType(value)} size="small" style={{width:'100%'}}>
                  <Select.Option value="CONTACTPERSON">Persona Natural</Select.Option>
                  <Select.Option value="CONTACTENTITY">Persona Jurídica</Select.Option>
                </Select>
              </Col>
              <Col span={10}>
              </Col>
            </>
            }
            { handleApplyFields &&
              <Col offset={18} span={6}>
                  <Search size="small" placeholder="Busque el nombre del campo" onChange={(e) => handleSearchField(e.target.value)} allowClear/>
              </Col>
            }
        </Row>
        */}
        <Row style={handleApplyFields && {paddingBottom:'20px'}}>
        { catalogos.map(cat =>
            <Catalogo section={section} catalogo={cat} handleChangeCatalogoActive={_handleChangeCatalogoActive} handlerChangeCatalogo={_handlerChangeCatalogo} />
        )}
        </Row>

        { handleApplyFields &&
            <div
                style={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                }}
            >
                <Button onClick={handleClose} style={{ marginRight: 8 }}>
                    {t('forms.buttons.cancel', {ns:'forms'})}
                </Button>
                <Button onClick={handleSendFields} type="primary">
                    {t('forms.buttons.add', {ns:'forms'})}
                </Button>
            </div>
        }
    </div>
  )

}

export default Catalogos;
